import QRCodeIcon from "../../../../../../../../../api/qr-code/icon/QRCodeIcon";
import classes from "./ListItem.module.css";
import {Image} from "@mantine/core";
import {useContext} from "react";
import QRCodeStyleViewContext from "../../../../QRCodeStyleViewContext";

type ListItemProps = {
    /**
     * Icon to be rendered
     * @author Kacper Faber
     * @since 0.1.9
    */
    icon: QRCodeIcon;
};

function ListItem(props: ListItemProps) {
    const ctx = useContext(QRCodeStyleViewContext);

    /**
     * Check if icon is active - this icon ID is the same as in style
     * @author Kacper Faber
     * @since 0.1.9
    */
    const isActive = () => {
        return ctx.payload?.icon === props.icon.id;
    }

    /**
     * On item is clicked
     * @author Kacper Faber
     * @since 0.1.9
    */
    const onClick = () => {
        if (!ctx.payload) {
            throw new Error('Could not update the payload, because payload in context is undefined.');
        }

        ctx.setPayload({...ctx.payload, icon: props.icon.id, iconInstance: props.icon});
    };

    /**
     * Get classes for this item
     * @author Kacper Faber
     * @since 0.1.9
    */
    const getClasses = () => {
        return `${classes.root} ${isActive() ? classes.active : classes.inactive}`;
    };

    return (
        <div className={getClasses()} onClick={onClick}>
            { props.icon.image ? <Image w={56} h={56} src={props.icon.image} /> : null }
        </div>
    );
}

export default ListItem;